<!--
 * @Author: fusiyuan 1152054863@qq.com
 * @Date: 2025-08-18 16:35:26
 * @LastEditors: fusiyuan 1152054863@qq.com
 * @LastEditTime: 2025-08-29 14:25:56
 * @FilePath: \slbq-web\management-side\src\views\KBManage\detailsView.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <page-title title="资源状态">
      <div style="display: flex; justify-content: space-between">
        <div class="title-status">
          <p>{{ getStatusCode(reviewForm.status) }}</p>
          <div
            class="audit"
            v-if="reviewForm.status != 1 && reviewForm.opinion"
          >
            审核意见：{{ reviewForm.opinion }}
          </div>
        </div>
        <el-button
          style="height: 34px"
          size="small"
          type="primary"
          @click="goback"
          >返回</el-button
        >
      </div>
    </page-title>
    <div class="work-review-container">
      <div class="left-section">
        <el-form
          :disabled="true"
          :model="uploadForm"
          :rules="rules"
          label-width="130px"
          size="small"
        >
          <el-form-item label="上传资源类型：" prop="type">
            <el-select v-model="uploadForm.type">
              <el-option label="图片" value="1"></el-option>
              <el-option label="音频" value="2"></el-option>
              <el-option label="视频" value="3"></el-option>
              <!-- 可根据实际情况添加更多选项 -->
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="请提交证明：" prop="project">
                        {{ uploadForm.project || '证明文件.docx' }}
                    </el-form-item> -->
          <!-- <div class="title-status" style="margin-bottom: 16px;">共1张(12.27MB)</div> -->
          <imgOrVideoDetail
            v-if="uploadForm.type != 2"
            :worksSize="uploadForm.size"
            :resourceType="uploadForm.type"
            :resourceUrl="uploadForm.file"
          ></imgOrVideoDetail>
          <audioDetail
            :fileName="uploadForm.fileName"
            :duration="uploadForm.duration"
            :resourceUrl="uploadForm.file"
            :worksSize="uploadForm.size"
            v-else
          ></audioDetail>
          <!-- <div class="image-container">
                        <div class="image-item" v-for="(image, index) in uploadForm.images" :key="index">
                            <el-image :src="image" class="images" :preview-src-list="uploadForm.images">
                            </el-image>
                            <div v-if="index === 0" class="watermark">相似图片需提交证明材料</div>
                        </div>
                    </div> -->
          <!-- <div class="similar-resource">
                        <h4 class="title-tip">相似资源</h4>
                        <div class="similar-resource-box">
                            <div class="similar-item" v-for="(similar, index) in uploadForm.similarResources" :key="index">
                            <el-image :src="similar.image"  class="images"
                                :preview-src-list="uploadForm.similarResources.map(v => v.image)">
                            </el-image>
                            <div class="similar-info">
                                <p>名称：{{ similar.name }}</p>
                                <p>相似度：{{ similar.similarity }}%</p>
                                <p>素材匹配：{{ similar.match }}</p>
                            </div>
                        </div>
                        </div>
                    </div> -->
        </el-form>
      </div>
      <div class="right-section">
        <el-form
          :disabled="!isEdit"
          :model="reviewForm"
          :rules="rules"
          ref="reviewForm"
          label-width="130px"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input
              v-model="reviewForm.title"
              placeholder="请输入"
              maxlength="25"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="核心关键词：" prop="keywords">
            <div class="keyword-count font-text">
              {{
                reviewForm.keywords
                  ? reviewForm.keywords
                      .split(/[,，]/)
                      .filter((item) => item.trim() !== "").length
                  : 0
              }}/20关键词
            </div>
            <el-input
              type="textarea"
              v-model="reviewForm.keywords"
              placeholder="0/20关键词"
            ></el-input>
            <!-- <div class="keyword-tips">多个关键词请用，分隔</div> -->
            <div class="recommended-keywords" v-if="isEdit">
              推荐关键词
              <span
                v-for="(keyword, index) in recommendedKeywords"
                @click="handleKeywords(keyword)"
                :key="index"
                style="cursor: pointer"
              >
                {{ keyword }}
              </span>
            </div>
          </el-form-item>
          <el-form-item label="分类：" prop="category">
            <el-select v-model="reviewForm.category" style="width: 100%">
              <el-option
                v-for="item in categorizeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 创作者 -->
          <el-form-item label="创作者" v-if="showCreate" prop="creator">
            <el-input
              show-word-limit
              type="text"
              v-model="reviewForm.creator"
              placeholder="请输入创作者"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
          <!-- 朝代 -->
          <el-form-item label="朝代" prop="dynasty">
            <el-select v-model="reviewForm.dynasty" placeholder="请选择">
              <el-option
                v-for="item in dynastyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 艺术形态 -->
          <el-form-item label="艺术形态" prop="artForm">
            <el-select v-model="reviewForm.artForm" placeholder="请选择">
              <el-option
                v-for="item in artFormList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 详情 -->
          <el-form-item label="详情" prop="resourceDesc">
            <div
              v-if="!isEdit"
              style="padding: 0 20px"
              v-html="reviewForm.resourceDesc"
            ></div>
            <Editor
              ref="editor"
              :isDisabled="!isEdit"
              v-else
              :value.sync="reviewForm.resourceDesc"
            />
          </el-form-item>
          <el-form-item label="" v-if="isEdit">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
        <el-form
          v-if="isExamine"
          :disabled="isDisable"
          :model="reviewForm"
          ref="form"
          label-width="130px"
          size="small"
        >
          <el-form-item label="审核意见">
            <el-input
              type="textarea"
              v-model="reviewForm.opinion"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="!isDisable">
            <el-button @click="rejectReview">审核拒绝</el-button>
            <el-button type="primary" @click="approveReview"
              >审核通过</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="审核拒绝"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
    >
      <el-form
        :model="dialogForm"
        ref="refuseForm"
        :rules="refuseRules"
        label-width="80px"
      >
        <el-form-item label="拒绝原因" prop="reason">
          <el-input
            maxlength="200"
            show-word-limit
            v-model="dialogForm.reason"
            type="textarea"
            :rows="3"
            placeholder="请输入拒绝原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRefuse('refuseForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import imgOrVideoDetail from "./imgOrVideoDetail.vue";
import audioDetail from "./audioDetail.vue";
import Editor from "@/views/contractManagement/editor.vue";

import {
  prodDetail,
  getCategorize,
  getPicture,
  updateStatus,
  editWork,
} from "@/api/works";
import { artForm, dynasty } from "@/utils/dict";

export default {
  name: "detailsView",
  components: {
    PageTitle,
    CusPagination,
    imgOrVideoDetail,
    audioDetail,
    Editor,
  },
  created() {
    this.getCategorizeFn();
    this.getPictureFn();
    this.getDetail();
  },
  data() {
    return {
      artFormList: artForm,
      dynastyList: dynasty,
      dialogVisible: false,
      dialogForm: {
        reason: "",
      },
      uploadForm: {
        type: "1",
        certificate: "",
        file: "",
        size: "",
        duration: "",
        workSize: "",
        fileName: "",
        images: [
          // 'https://oss.slbqw.com/slbqw-update/49/oss20250508094742mmw2al.jpg',
          // 'https://oss.slbqw.com/slbqw-update/49/oss20250508094742mmw2al.jpg',
          // 'https://oss.slbqw.com/slbqw-update/49/oss20250508094742mmw2al.jpg',
        ],
        similarResources: [
          {
            image:
              "https://oss.slbqw.com/slbqw-update/49/oss20250508094742mmw2al.jpg",
            name: "名称",
            similarity: 80,
            match: "xxxx, xxxx",
          },
          {
            image:
              "https://oss.slbqw.com/slbqw-update/49/oss20250508094742mmw2al.jpg",
            name: "名称",
            similarity: 80,
            match: "xxxx, xxxx",
          },
        ],
      },
      reviewForm: {
        isRegistered: "1",
        registrationNumber: "",
        certificateFile: "",
        title: "",
        keywords: "",
        category: "",
        creationDate: "",
        creationPlace: "",
        portraitRight: "",
        nature: "创作性质: 原创",
        scope: "权利范围: 全部权利",
        author: "著作权人: 企业/个人认证名称",
        opinion: "",
        status: "",
        resourceDesc: "",
        artForm: "",
        dynasty: "",
        creator: "",
      },
      rules: {
        type: [
          { required: true, message: "请选择上传作品类型", trigger: "change" },
        ],
        project: [
          { required: true, message: "请上传证明文件", trigger: "blur" },
        ],
        dynasty: [{ required: true, message: "请选择朝代", trigger: "change" }],
        creator: [
          { required: true, message: "请输入著作权人", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        keywords: [
          {
            required: true,
            max: 20,
            message: "关键词不能超过20个字符",
            trigger: "blur",
          },
        ],
        category: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        creationDate: [
          { required: true, message: "请选择创作完成日期", trigger: "change" },
        ],
        artForm: [
          { required: true, message: "请选择艺术形态", trigger: "change" },
        ],
        resourceDesc: [
          { required: true, message: "请输入资源描述", trigger: "blur" },
        ],
      },
      refuseRules: {
        reason: [
          { required: true, message: "请输入拒绝原因", trigger: "submit" },
        ],
      },
      recommendedKeywords: [],
      categorizeList: [],
    };
  },
  computed: {
    isDisable() {
      return this.$route.params.type == "1";
    },
    isEdit() {
      return this.$route.params.type == "3";
    },
    isExamine() {
      return this.$route.params.type == "2";
    },
    currentId() {
      return this.$route.params.id;
    },
    showCreate() {
      return (
        this.categorizeList.find((item) => item.id == this.reviewForm.category)
          ?.name == "共创作品"
      );
    },
  },
  methods: {
    submitForm() {
      this.$refs.reviewForm.validate((valid) => {
        const {
          artForm,
          category,
          creator,
          dynasty,
          id,
          keywords,
          resourceDesc,
          title,
        } = this.reviewForm;

        if (valid) {
          this.$ajax
            .post(editWork, {
              artForm,
              category,
              creator,
              dynasty,
              id,
              keywords,
              resourceDesc,
              title,
            })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success("修改成功");
                this.$router.go(-1);
              }
            });
        } else {
          console.log("校验失败");
        }
      });
    },

    getDetail() {
      this.$ajax.get(prodDetail(this.currentId)).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data;
          // 使用对象解构和属性重命名简化赋值
          const {
            worksType,
            worksUrl: file,
            worksSize: size,
            status,
            isRegistered,
            registrationCode: registrationNumber,
            certificateUrl: certificateFile,
            title,
            keywords,
            category,
            finishTime: creationDate,
            finishAddress: creationPlace,
            portraitRight,
            opinion,
            duration,
            fileName,
          } = data;

          // 上传表单数据
          this.uploadForm = {
            ...this.uploadForm,
            type: String(worksType),
            file,
            size,
            duration,
            fileName,
          };

          // 审核表单数据
          this.reviewForm = {
            ...this.reviewForm,
            ...data,
            isRegistered: String(isRegistered),
            registrationNumber,
            certificateFile,
            title,
            keywords,
            category,
            creationDate,
            creationPlace,
            portraitRight: String(portraitRight),
            opinion,
            status,
          };
          if (this.reviewForm.status == 1) {
            this.reviewForm.opinion = "";
          }
        }
      });
    },
    handleKeywords(keyword) {
      let arr = [];
      if (this.reviewForm.keywords) {
        arr = this.reviewForm.keywords.split(",");
        // 判断是否有重复
        const isHas = arr.every((item) => item !== keyword);
        if (!isHas) return;
      }
      arr.push(keyword);
      this.reviewForm.keywords = arr.join(",");

      // 手动触发表单验证清除
      this.$nextTick(() => {
        this.$refs.reviewForm.validateField("keywords");
      });
    },
    rejectReview() {
      // 审核拒绝逻辑，可发送请求到后端
      // this.dialogVisible = true;
      if (!this.reviewForm.opinion) {
        return this.$message.error("请输入审核意见");
      }
      console.log("审核拒绝");
      this.approve(3, this.reviewForm.opinion);
    },
    approveReview() {
      // 审核通过逻辑，可发送请求到后端
      this.approve(5, this.reviewForm.opinion);
      console.log("审核通过");
    },
    confirmRefuse(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          // 发送拒绝请求到后端
          console.log("拒绝原因:", this.dialogForm.reason);
          this.approve(3, this.dialogForm.reason);
        }
      });
    },
    goback() {
      this.$router.push({ path: "/KBManage" }); // 替换为实际的路由路径
    },
    getCategorizeFn() {
      this.$ajax.get(getCategorize, { type: 4 }).then((res) => {
        if (res.data.code == 200) {
          this.categorizeList = res.data.data;
        }
      });
    },
    getPictureFn() {
      this.$ajax.get(getPicture, { type: 4 }).then((res) => {
        if (res.data.code == 200) {
          this.recommendedKeywords = res.data.data.map((item) => item.name);
        }
      });
    },
    getStatusCode(status) {
      const map = {
        5: "销售中",
        4: "待发布",
        1: "审核中",
        3: "未通过",
      };
      return map[status] || "";
    },
    approve(status, reason) {
      this.$ajax
        .post(updateStatus, {
          id: this.currentId,
          status: status,
          opinion: reason,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.$router.push({ path: "/KBManage" }); // 替换为实际的路由路径
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.work-review-container {
  display: flex;
  background-color: #ffffff;
}
.font-text {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: px2rem(14);
  color: #999999;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.left-section {
  width: 50%;
  padding: 20px;
}

.right-section {
  width: 50%;
  padding: 20px;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
}

.image-item {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  width: 28%;
  margin-right: 2%;

  /deep/ .images {
    width: 100%;
    border-radius: 14px;

    .el-image__inner {
      width: 100%;
      height: 300px;
      object-fit: cover;
    }
  }
}
.similar-resource-box {
  display: flex;
}
.similar-item {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  width: 28%;
  margin-right: 2%;
  /deep/ .images {
    width: 100%;
    border-radius: 14px;

    .el-image__inner {
      width: 100%;
      height: 300px;
      object-fit: cover;
    }
  }
}
.watermark {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px;
}

.similar-resource {
  margin-top: 20px;
}

.similar-info {
  margin-left: 10px;
}

.keyword-tips {
  font-size: 12px;
  color: #999;
}

.recommended-keywords {
  margin-top: 5px;
  font-size: 12px;
  color: #999;

  span {
    background-color: #002b9c;
    color: #ffffff;
    text-align: center;
    padding: 4px 8px;
    border-radius: 6px;
    display: inline-block;
    line-height: 20px;
    margin-right: 10px;
  }
}
.audit {
  font-weight: 400;
  font-size: 14px;
  color: #ff0000;
  margin-top: 20px;
}
.title-status {
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.el-button--primary {
  color: #fff;
  background-color: #002b9c;
  border-color: #002b9c;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #002b9c;
  background: #002b9c;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #002b9c;
}

.automatic {
  background: #f6f9ff;
  border-radius: 0px 0px 0px 0px;
  padding: 10px;
  margin-bottom: 30px;

  .automatic-tit {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .automatic-count {
    margin-top: 10px;
    display: flex;

    div {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #444444;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 30px;
    }
  }
}
.title-tip {
  margin-bottom: 16px;
}
</style>
